import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { brushOptionsState } from '~/state/atoms/toolsAtoms';
import { mmToCm } from '~/utils/units';

const BrushDiameterLabel = () => {
    const brushOptions = useRecoilValue(brushOptionsState);
    return (
        <Box
            sx={{
                position: 'relative',
                fontSize: '12px',
                display: 'flex',
                gap: '0.5em',
            }}
        >
            <Typography fontSize={12}>
                <FormattedMessage id="brushWidth" />:
            </Typography>
            <Typography fontSize={12}>
                {mmToCm(brushOptions.diameter).toFixed(1)}
            </Typography>
        </Box>
    );
};

export default BrushDiameterLabel;
